import { parseISO } from 'date-fns';
import { formatDateToMonthAndYear } from '@/utils/dateFormatting';
import type { PatientTimelineEvent } from '@/api/patients/patientsApi.types';

export interface TimelineMonthGroup {
  monthLabel: string;
  events: PatientTimelineEvent[];
}

export function groupTimelineEventsByMonth(
  events: PatientTimelineEvent[]
): TimelineMonthGroup[] {
  const groups: TimelineMonthGroup[] = [];
  let currentGroup: TimelineMonthGroup | null = null;
  for (const event of events) {
    const monthLabel = formatDateToMonthAndYear(parseISO(event.eventDate));
    if (currentGroup !== null && currentGroup.monthLabel === monthLabel) {
      currentGroup.events.push(event);
    } else {
      currentGroup = { monthLabel, events: [event] };
      groups.push(currentGroup);
    }
  }
  return groups;
}
